import api, { refreshAccessToken } from '../utils/api'

class AuthService {
  constructor() {
    
  }

  async login(credentials) {
    try {
      const response = await api.post('/admin/login', credentials)
      const { agent, token, refreshToken: refresh_token } = response.data

      // Store tokens
      this.setTokens(token, refresh_token)
      this.setUser(agent)

      return { success: true, data: { agent, token, refresh_token } }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || error.response?.data?.message || 'Login failed' 
      }
    }
  }

  async register(agentData) {
    try {
      const response = await api.post('/admin/register', agentData)
      const { agent, token, refreshToken: refresh_token } = response.data

      // Store tokens
      this.setTokens(token, refresh_token)
      this.setUser(agent)

      return { success: true, data: { agent, token, refresh_token } }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Registration failed' 
      }
    }
  }

  async refreshToken() {
    const token = await refreshAccessToken()
    return { success: true, token }
  }

  async logout() {
    api.post('/admin/logout').catch(() => {})

    this.clearAuth()
    return { success: true }
  }

  // Token management
  setTokens(accessToken, refreshToken) {
    localStorage.setItem('agent_token', accessToken)
    localStorage.setItem('agent_refresh_token', refreshToken)
    api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  }

  getAccessToken() {
    return localStorage.getItem('agent_token')
  }

  getRefreshToken() {
    return localStorage.getItem('agent_refresh_token')
  }

  // User management
  setUser(user) {
    localStorage.setItem('agent_user', JSON.stringify(user))
  }

  getUser() {
    const userData = localStorage.getItem('agent_user')
    try {
      return userData ? JSON.parse(userData) : null
    } catch (error) {
      console.error('Failed to parse user data:', error)
      return null
    }
  }

  // Auth state
  isAuthenticated() {
    const token = this.getAccessToken()
    const refreshToken = this.getRefreshToken()
    return !!(token && refreshToken)
  }

  isTokenExpired(token = null) {
    const accessToken = token || this.getAccessToken()
    if (!accessToken) return true

    try {
      const payload = JSON.parse(atob(accessToken.split('.')[1]))
      const currentTime = Date.now() / 1000
      // Add 5 minute buffer
      return payload.exp < (currentTime + 300)
    } catch (error) {
      return true
    }
  }

  // Clear all auth data
  clearAuth() {
    localStorage.removeItem('agent_token')
    localStorage.removeItem('agent_refresh_token')
    localStorage.removeItem('agent_user')
    delete api.defaults.headers.common['Authorization']
  }

  // Initialize auth state (for app startup)
  initialize() {
    const token = this.getAccessToken()
    if (token && !this.isTokenExpired(token)) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      return true
    } else if (token && this.isTokenExpired(token)) {
      // Token expired, try to refresh
      const refreshToken = this.getRefreshToken()
      if (refreshToken) {
        // Don't await here to avoid blocking app initialization
        this.refreshToken().catch(() => {
          this.clearAuth()
        })
        return true
      }
    }
    
    this.clearAuth()
    return false
  }

  // Get current auth state
  getAuthState() {
    return {
      isAuthenticated: this.isAuthenticated(),
      user: this.getUser(),
      token: this.getAccessToken(),
      refreshToken: this.getRefreshToken()
    }
  }
}

export default new AuthService()